import { html } from 'lit-element';

import FormButton from './FormButton';

export class WizardNext extends FormButton {
    render() {
        return html`
            <span style="display:${this.step < this.metadata.length ? 'inherit' : 'none'}">
                ${super.render()}
            </span>
        `;
    }

    submit(evt) {
        this.blur();
        return super.submit(evt);
    }
}

export default () => customElements.define('e2-wizard-next', WizardNext);
